module.exports = __webpack_public_path__ + "static/linkedin-75d2ca104a1903bc305fa6eed718012d.png";